import { ChangeDetectionStrategy, Component, effect, inject, input, output, ViewChild } from '@angular/core';
import { Button } from 'primeng/button';
import { Popover } from 'primeng/popover';
import { SvgIconComponent } from 'angular-svg-icon';
import { ScreenResolutionService } from '@app/core/services/screen-resolution/screen-resolution.service';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputText } from 'primeng/inputtext';
import { numberPattern } from '@app/shared/validators/patterns';
import { LocaleNumberPipe } from '@app/shared/pipes/locale-number/locale-number.pipe';
import { propagateTableEventClickManually } from '@app/main/main-content/main-table/helpers/propagate-table-event-click-manually';

@Component({
  selector: 'gc-ld-logger-noise-env-noise-edit',
  standalone: true,
  imports: [
    Button,
    Popover,
    SvgIconComponent,
    NgTemplateOutlet,
    NgClass,
    TranslatePipe,
    TranslateDirective,
    FormsModule,
    InputText,
    ReactiveFormsModule,
    LocaleNumberPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ld-logger-noise-env-noise-edit.component.html',
  host: {
    class: 'flex items-center justify-center w-full',
  },
})
export class LdLoggerNoiseEnvNoiseEditComponent {
  private scrRes = inject(ScreenResolutionService);

  public value = input.required<number | undefined>();
  public serialNo = input.required<string>();
  public popoverStyleClass = input<string>('z-screen-container-0');

  public save = output<number>();

  public formGroup = new FormGroup({
    envNoiseDecibel: new FormControl<number | null>(null, [Validators.required, Validators.pattern(numberPattern)]),
  });

  @ViewChild('popover') private popover: Popover | undefined;

  constructor() {
    effect(() => {
      const value = this.value();

      this.formGroup.controls.envNoiseDecibel.setValue(value ?? null);
    });
    effect(() => {
      this.scrRes.breakpoint();
      this.popover?.hide();
    });
  }

  public onSubmit() {
    const value = this.formGroup.controls.envNoiseDecibel.value;

    this.popover?.hide();

    if (value !== null && value !== undefined) {
      this.save.emit(value);
    }

    // TODO: wire up persistence of env. noise (same stub as the logger noise table cell)
    console.log('save env. noise', this.formGroup.value);
  }

  protected readonly propagateEventClickManually = propagateTableEventClickManually;
}
